import { createAction } from "redux-act";
import { IError } from "modules/types";

export const globalError = createAction<Error | string>();
export const showGlobalError = createAction<IError>();
export const clearGlobalError = createAction();